import { render, staticRenderFns } from "./TopicOverView.vue?vue&type=template&id=52bb2e5c&scoped=true"
import script from "./TopicOverView.vue?vue&type=script&lang=js"
export * from "./TopicOverView.vue?vue&type=script&lang=js"
import style0 from "./TopicOverView.vue?vue&type=style&index=0&id=52bb2e5c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bb2e5c",
  null
  
)

export default component.exports